export default [
  {
    name: `splash_screen`,
    title: `Welcome to the virtual tour of the Vertical Farm`,
    lang: `Select your <br /><span i>language</span>`,
  },
];
